var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.07 10.32C17.88 10.32 17.69 10.25 17.54 10.1L12 4.56L6.46 10.1C6.17 10.39 5.69 10.39 5.4 10.1C5.11 9.81 5.11 9.33 5.4 9.04L11.47 2.97C11.76 2.68 12.24 2.68 12.53 2.97L18.6 9.04C18.89 9.33 18.89 9.81 18.6 10.1C18.46 10.25 18.26 10.32 18.07 10.32Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.25C11.59 21.25 11.25 20.91 11.25 20.5V3.67001C11.25 3.26001 11.59 2.92001 12 2.92001C12.41 2.92001 12.75 3.26001 12.75 3.67001V20.5C12.75 20.91 12.41 21.25 12 21.25Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.16184a801ece26ed66c359660c24a272.svg";
export { ForwardRef as ReactComponent };